module.exports = __webpack_public_path__ + "img/top-bg.2c04e6c2.png";